import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

function publicClient() {
  const url = process.env.SUPABASE_URL!;
  const key = process.env.SUPABASE_PUBLISHABLE_KEY!;
  return createClient<Database>(url, key, {
    auth: { persistSession: false, autoRefreshToken: false, storage: undefined },
  });
}

export type PublicPost = {
  slug: string;
  title: string;
  description: string;
  keywords: string;
  category: string;
  body: string;
  read_minutes: number;
  published_at: string | null;
  updated_at: string;
};

export const listPublishedPosts = createServerFn({ method: "GET" }).handler(
  async (): Promise<PublicPost[]> => {
    const supabase = publicClient();
    const { data, error } = await supabase
      .from("blog_posts")
      .select(
        "slug,title,description,keywords,category,body,read_minutes,published_at,updated_at",
      )
      .eq("published", true)
      .order("published_at", { ascending: false });
    if (error) throw new Error(error.message);
    return data ?? [];
  },
);

export const getPublishedPost = createServerFn({ method: "GET" })
  .inputValidator((data: { slug: string }) => data)
  .handler(async ({ data }): Promise<PublicPost | null> => {
    const supabase = publicClient();
    const { data: row, error } = await supabase
      .from("blog_posts")
      .select(
        "slug,title,description,keywords,category,body,read_minutes,published_at,updated_at",
      )
      .eq("slug", data.slug)
      .eq("published", true)
      .maybeSingle();
    if (error) throw new Error(error.message);
    return row;
  });
